import { useState } from 'react'

import { ScheduleScreen, shownError, syncSchedule, syncScheduleSave, type ShownError } from '@krp/sync-ui'

import { queryState } from './syncKit'

/** Время ночной сверки (RP-SYN8, требования 13). Пока поле не трогали, показывается сохранённое время службы. */
export function SyncScheduleBinding() {
  const query = syncSchedule.useQuery()
  const [save] = syncScheduleSave.useMutation()
  const [edited, setEdited] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<ShownError | null>(null)
  const [saved, setSaved] = useState(false)

  const draft = edited ?? query.data?.nightlyAt ?? ''

  const run = () => {
    setBusy(true)
    setError(null)
    void save({ nightlyAt: draft })
      .unwrap()
      .then(() => {
        setEdited(null)
        setSaved(true)
      })
      .catch((reason: unknown) => setError(shownError('Время не сохранено', reason)))
      .finally(() => setBusy(false))
  }

  const state = queryState(query, 'Не удалось получить расписание')
  return (
    <ScheduleScreen
      vm={{ status: state.status, loadError: state.loadError, schedule: query.data ?? null, draft, busy, error, saved }}
      actions={{
        draftChanged: (time) => {
          setEdited(time)
          setSaved(false)
        },
        save: run,
        reload: () => void query.refetch(),
      }}
    />
  )
}
